import { isMockingEnabled, startMockWorker } from '@crossbeam/mocks';

import { typedHttp } from './typedHttp';

/** Starts the dev-only msw worker and hands the console its driver. The
 * handlers are imported from here so a production build never reaches them. */
async function initializeMockServer() {
  if (!isMockingEnabled()) return;

  const { SCENARIOS, buildDefaultHandlers } = await import('./handlers');
  await startMockWorker({
    handlers: await buildDefaultHandlers(),
    scenarios: SCENARIOS,
  });
}

export { initializeMockServer, typedHttp };
